<!--
     注意，
       1. 尺寸是在设计稿 975px 上设计的
       2. Caption 是 HTML 上的敏感关键词，不能直接使用 <caption></caption> 的方式引用，否则不显示
       3. 不要设置宽度，宽度由外部容器来指定，让 el-row 自适应容器的宽度，这样才能 px to viewport
-->
<template>
    <el-row class="caption">
        <el-col :span="4" align="left">
            <!-- 增加审核逻辑 -->
            <avatar v-if="!showAvatar && name!=null" :hash="name" :size="avatarSize"></avatar>
            <avatar v-else-if="showAvatar" :url="url" :size="avatarSize"></avatar>
        </el-col>
        <el-col :span="20" style="font-size:14px" align="left">
            <el-card shadow="never" body-style="padding: 0 0 0 0;" >
                <profile-name :name="name" :code="code" :style-object="{lineHeight: '30px', fontWeight: '600', fontSize: '14px', marginBottom: '8px'}"></profile-name>
                <div class="caption-text" style="white-space: pre-wrap;">{{text}}</div>
                <div class="tail margin-top-8px">
                    <div class="font-gray" style="font-size:13px">{{timestamp}}</div>
                    <!-- 记得 shortcode 千万不要从 params 中取 $route.params.shortcode，否则 PC 端弹出框是获取不到的，从而报错 -->
                    <tipoff type="entity" :id="$store.state.currentEntity.shortcode">
                        <my-link class="margin-left-8px tipoff-link">举报</my-link>
                    </tipoff>
                    <blacklist :code="code" type="profile" v-if="isHybridAgent"></blacklist>
                </div>
            </el-card>
            <slot></slot>
        </el-col>
    </el-row>
</template>

<script>
    import ProfileName from "../profile/Name";
    import Blacklist from "../commons/Blacklist";
    import { isHybridAgent } from "../../utils";

    export default {
        name: "Caption",
        components: {
            Blacklist,
            ProfileName,
        },
        computed: {
            isHybridAgent(){
                return isHybridAgent()
            },
            showAvatar(){
                if (this.$store.state.displayCtrl !== null){
                    return this.$store.state.displayCtrl.avatar;
                }else{
                    return false;
                }
            }
        },
        props: {
            avatarSize: {
                type: Number,
                default: 35
            },
            url: String,
            name: String,
            code: String, // profile code
            text: String,
            timestamp: String
        }
    }
</script>

<style scoped>

    /* 消除 el-card 默认的 1px gray border */
    .el-card {
        border: 0px;
    }

    .caption {
        margin-top:12px;
    }

    .caption .name{
        font-weight: 600;
    }

    .caption .tail {
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
        line-height: 16px; /* 这样才能让 tipoffs 高度居中对齐 */
        height: 16px;
        width: 90%;
    }

    /* h5 中已经禁止了长按事件，但是 caption 信息是允许用户复制的，便于用户发标内容 */
    .caption-text {
        -webkit-user-select: auto !important;
        user-select:auto !important;
        white-space: pre-wrap !important;
    }

    .tipoff-link {
        font-size: 13px !important;
        font-weight: 400 !important;
        color: #303133
    }

    @media (min-width: 976px) {
        .caption {
            margin-top:12px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/comments/Caption.vue